<template>
  <div id="fileCategoryAdd">
      <v-layout wrap row mb-1>
      <v-flex md6 pb-4 style="min-height:70px;">
        <v-btn fab left to="/FileCategories" class="ml-3 pf-btn-fab">
          <v-icon>arrow_back</v-icon>
        </v-btn>
         </v-flex>
        <v-flex offset-md1 md5 v-if="selectedData">
        <div style="float:right">
          <v-btn class="pf-btn pf-btn-cancel" to="/FileCategories">
            <v-icon size="16" class="pr-1">cancel</v-icon>
            <div>Cancel</div>
          </v-btn>
          <v-btn class="pf-btn pf-btn-save" @click="save">
            <v-icon size="16" class="pr-1">check_circle</v-icon>
            <div>Save</div>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <v-form ref="fileCategoryAdd">
      <v-container>
        <v-layout>
          <v-flex class="xs12 sm6 md7">
            <v-text-field label="Name" :rules="rules" v-model.trim="FileCategoryModel.name" class="required pr-4 pl-4" @input="changedData" required></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="xs12 sm6 md7">
            <v-textarea label="Description" rows="3" :rules="descriptionRules" v-model.trim="FileCategoryModel.description" class="required pr-4 pl-4" @input="changedData" required></v-textarea>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex class="xs12 sm6 md7">
            <v-combobox
              v-model="FileCategoryModel.notify"
              :items="agencyAdminList"
              label="Select to notify"
              item-text="name"
              item-value="human"
              multiple
              class="pr-4 pl-4"
              @input="changedData"
            ></v-combobox>
          </v-flex>
        </v-layout>

      </v-container>
    </v-form>
      <v-layout class="editor-button-container">
        <v-flex xs12 class="button-container text-xs-right" v-if="selectedData">
          <div class="d-inline-flex">
            <v-btn class="pf-btn pf-btn-cancel" to="/FileCategories">
              <v-icon size="16" class="pr-1">cancel</v-icon>
              <div>Cancel</div>
            </v-btn>
            <v-btn class="pf-btn pf-btn-save" @click="save">
              <v-icon size="16" class="pr-1">check_circle</v-icon>
              <div>Save</div>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
  </div>
</template>

<script>
/* global session store */
import { create, getCollection, validateUrl } from '../helpers/helpers';
import swal from 'sweetalert2';
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default {
  name: 'fileCategoryAdd',
  data: () => ({
    selectedData: false,
    FileCategoryModel: {
      name: '',
      description: '',
      notify: []
    },
    rules: [
      v => !!v.trim() || 'Name is required'
    ],
    descriptionRules: [
      v => !!v.trim() || 'Description is required'
    ]
  }),
  computed: {
    fileCategoryList: {
      get () {
        return store.state.FileCategory;
      },
      set (value) {
        store.commit('setFileCategory', value);
      }
    },
    agencyAdminList: {
      get () {
        return store.state.AdminList;
      },
      set (value) {
        store.commit('setAdminList', value);
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  created () {
    this.getFileCategories();
    this.getAgencyAdmins();
  },
  mounted () {
    window.getApp.$emit('pageSubHeader', 'Add');
  },
  methods: {
    async getFileCategories () {
      if (!this.fileCategoryList.length) {
        let entity = `FileCategory`;
        let { error, data } = await getCollection(entity, true);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.fileCategoryList = data;
          }
        }
      }
    },
    async save () {
      if (this.$refs.fileCategoryAdd.validate()) {
        this.selectedData = false;
        let selectedString = [];
        let newFileCategory = { ...this.FileCategoryModel };
        newFileCategory.notify.forEach(function (v) { 
          selectedString.push(v.human);
        });
        newFileCategory.notify = selectedString;
        let { error, data, status } = await create('FileCategory', newFileCategory);
        if (error) {
          this.selectedData = true;
          console.log('error', error);
        } else {
          this.fileCategoryList.push(data);
          swal.fire({
            type: 'success',
            title: 'Category added successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              this.$router.push({ path: '/FileCategories' });
            }
          });
        }
      }
    },
    async getAgencyAdmins () {
      if (!this.agencyAdminList.length) {
        let where = { is_admin: true };
        let attributes = 'name';
        let populate = [{ path: 'human', select: '_id' }];
        let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes);
        if (error) {
          console.log(error);
        } else {
          if (data.length > 0) {
            this.agencyAdminList = data;
            this.agencyAdminList.map(function (item) {
              item.human = item.human[0].id;
              return item;
            });
          }
        }
      }
    },
    changedData () {
      this.selectedData = true;
    },
  }
};
</script>

<style lang="css" scoped>
  .editor-button-container{
    padding-top: 70px;
  }

  #fileCategoryAdd >>> .v-textarea textarea {
    margin-top: 12px !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/FileCategoryAdd.vue